<nz-select id="persona-dropdown" class="persona-drop-down"
  #select
  #popover="nzPopover"
  nz-popover
  nzPopoverTrigger="click"
  nzNotFoundContent=""
  nzPlaceHolder="Everyone"
  [nzPopoverPlacement]="'bottomRight'"
  [ngModel]="selectedPersonaUI$ | async"
  [compareWith]="comparator"
  [nzDropdownStyle]="{ display: 'none' }"
  [nzPopoverContent]="popOverContent"
  [nzCustomTemplate]="selectedTpl"
  (nzVisibleChange)="changeSelectOpen($event, select)">
  <nz-option [nzValue]="selectedPersonaUI$ | async" [nzLabel]="(selectedPersonaUI$ | async)?.title"></nz-option>
</nz-select>
<ng-template #selectedTpl let-selected>
  <nz-avatar
    class="select-image"
    nzSize="small"
    nzShape="square"
    *ngIf="isTypePersona(selected.nzValue?.type)"
    [nzSrc]="selected.nzValue?.imgSrc"
    [nzIcon]="selected.nzValue?.icon"></nz-avatar>
  <span class="selected-label">{{selected.nzLabel}}</span>
</ng-template>
<ng-template #popOverContent>
  <div class="pop-over-content-box">
    <app-persona-list (ngModelChange)="onSelect($event, popover)"></app-persona-list>
  </div>
</ng-template>